import * as Yup from "yup";
import {validationsLocale} from "./ValidationsLocale";
import {__} from "@wordpress/i18n";

// Configuração de localidade para mensagens de validação
Yup.setLocale(validationsLocale);

// Mensagens de validação centralizadas
const MESSAGES = {
    required: __("Este campo é de preenchimento obrigatório.", "df-simulators"),
    loanValueRequired: __('O campo "Capital em dívida" é obrigatório.', "df-simulators"),
    loanValueTypeError: __('O campo "Capital em dívida" deve ser um número.', "df-simulators"),
    loanValuePositive: __('O campo "Capital em dívida" deve ser um número positivo.', "df-simulators"),
    loanValueMin: __('O valor do "Capital em dívida" deve ser maior que zero.', "df-simulators"),
    interestRateRequired: __('O campo "Taxa de juro" é obrigatório.', "df-simulators"),
    interestRateTypeError: __('O campo "Taxa de juro" deve ser um número.', "df-simulators"),
    interestRatePositive: __('O campo "Taxa de juro" deve ser um número positivo.', "df-simulators"),
    installmentsRequired: __('O campo "Prestações a pagar" é obrigatório.', "df-simulators"),
    installmentsTypeError: __('O campo "Prestações a pagar" deve ser um número.', "df-simulators"),
    installmentsInteger: __('O campo "Prestações a pagar" deve ser um número inteiro.', "df-simulators"),
    installmentsMin: __('O valor das "Prestações a pagar" deve ser maior que zero.', "df-simulators"),
};

// Esquema de validação para o formulário de simulação de prestação de crédito
export const validations: Record<string, Yup.ObjectSchema<any>> = {
    mortgage_payment: Yup.object().shape({
        loan_value: Yup.number()
            .required(MESSAGES.loanValueRequired)
            .typeError(MESSAGES.loanValueTypeError)
            .positive(MESSAGES.loanValuePositive)
            .min(1, MESSAGES.loanValueMin), // Valor mínimo ajustado para 1

        interest_rate: Yup.number()
            .required(MESSAGES.interestRateRequired)
            .typeError(MESSAGES.interestRateTypeError)
            .positive(MESSAGES.interestRatePositive), // Deve ser positiva

        installments_to_pay: Yup.number()
            .required(MESSAGES.installmentsRequired)
            .typeError(MESSAGES.installmentsTypeError)
            .integer(MESSAGES.installmentsInteger) // Deve ser um número inteiro
            .positive(MESSAGES.installmentsMin)// Deve ser positiva
            .min(1, MESSAGES.installmentsMin), // Valor mínimo ajustado para 1
    }),
};
